module.exports = __webpack_public_path__ + "static/media/2.e1aa4ee9.png";